module.exports = __webpack_public_path__ + "img/11.3770c1b7.jpg";